import getMessageErrorLabel from "../const/messageErrors";

export const TEMPLATE_PROVIDER_FALLBACK_MESSAGE =
  "No se pudo crear la plantilla de WhatsApp. Contacta a soporte.";
// Meta Cloud API 368 means an account policy restriction, not a template defect.
// https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes/
// Reuse the existing dictionary without changing its other consumers.
export const TEMPLATE_PROVIDER_POLICY_MESSAGE = getMessageErrorLabel(368);

// Subcodes of Meta's providerCode 100 whose meaning was verified against Meta
// through 360dialog with a controlled test on 2026-10-13. The backend sends only
// the numbers (never provider prose), so the explanation lives here. Subcodes are
// not a stable public contract: add one only after verifying it the same way.
const DELETED_NAME_MESSAGE =
  "WhatsApp todavía está eliminando una plantilla con este nombre. Usa otro nombre; si la plantilla anterior ya estaba aprobada, el nombre puede tardar hasta 30 días en liberarse.";

export const TEMPLATE_PROVIDER_SUBCODE_MESSAGES = {
  // Fewer examples than variables, or an example is empty.
  2388043:
    "Falta el ejemplo de una o más variables. Escribe un ejemplo para cada variable del mensaje e intenta de nuevo.",
  // A template with that name was deleted recently ("language is being deleted").
  2388023: DELETED_NAME_MESSAGE,
  // Same recently-deleted name, and the new attempt uses a different category.
  2388025: DELETED_NAME_MESSAGE,
  // The body starts or ends with a variable (also behind . ! ? or wrapped in * _).
  2388299:
    "El mensaje no puede empezar ni terminar con una variable. Agrega texto antes y después; los signos . ! ? y el formato * _ no cuentan como texto.",
};

// Takes the validated output of `templateProviderDiagnostics`. The meaning only
// holds for providerCode 100: the same subcode under another code is unknown.
export function templateProviderSubcodeMessage(diagnostics) {
  if (!diagnostics || diagnostics.providerCode !== 100) return null;
  const { providerSubcode } = diagnostics;
  // Integers only: "2388043" (a string) or a name like "constructor" must not match.
  if (!Number.isSafeInteger(providerSubcode)) return null;
  return TEMPLATE_PROVIDER_SUBCODE_MESSAGES[providerSubcode] ?? null;
}

// Match the server's prefix/base36-time/six-character-random reference format.
// Prefixes are not restricted to templates: these clients serve other features.
const SUPPORT_REF_PATTERN = /^[a-z][a-z0-9]*-[a-z0-9]+-[a-z0-9]{6}$/;
const MAX_SUPPORT_REF_LENGTH = 64;

export function templateProviderDiagnostics(body) {
  const diagnostics = {};
  if (!body || typeof body !== "object" || Array.isArray(body)) return diagnostics;

  ["providerCode", "providerSubcode"].forEach((field) => {
    if (Number.isSafeInteger(body[field]) && body[field] >= 0) {
      diagnostics[field] = body[field];
    }
  });

  const { supportRef } = body;
  if (
    typeof supportRef === "string" &&
    supportRef.length <= MAX_SUPPORT_REF_LENGTH &&
    SUPPORT_REF_PATTERN.test(supportRef) &&
    !/\s/.test(supportRef)
  ) {
    diagnostics.supportRef = supportRef;
  }
  return diagnostics;
}
